import * as mutationTypes from './mutation-types'
import api from '../api/remark-tags'

const RemarkTags = {
  state() {
    return {
      allRemarkTags: {},
      workflowReviewTags: [],
      workflowReviewActiveTagId: null,
    }
  },

  getters: {
    remarkTagById: (state) => (id) => {
      return state.allRemarkTags[id]
    },
    talkingPointTag: (state) => {
      return Object.values(state.allRemarkTags).find((tag) => tag.talkingPoint)
    },
  },

  mutations: {
    [mutationTypes.SET_ALL_REMARK_TAGS](state, tags) {
      state.allRemarkTags = tags
    },
    [mutationTypes.SET_WORKFLOW_REVIEW_TAGS](state, tags) {
      state.workflowReviewTags = tags
    },
    [mutationTypes.SET_WORKFLOW_REVIEW_ACTIVE_TAG](state, tag) {
      // tag is null => clear the tagId
      const id = tag ? tag.id : null

      state.workflowReviewActiveTagId =
        state.workflowReviewActiveTagId === id ? null : id
    },
  },

  actions: {
    setWorkflowReviewActiveTag({ commit }, tag) {
      commit(mutationTypes.SET_WORKFLOW_REVIEW_ACTIVE_TAG, tag)
    },
    fetchTagCloud({ commit, state }, { workflowId, ledgerId }) {
      api.getTagCloud(workflowId, ledgerId).then((data) => {
        commit(mutationTypes.SET_WORKFLOW_REVIEW_TAGS, data)

        const index = state.workflowReviewTags.findIndex(
          (tag) => tag.id === state.workflowReviewActiveTagId
        )

        if (index === -1) {
          commit(mutationTypes.SET_WORKFLOW_REVIEW_ACTIVE_TAG, null)
        }
      })
    },
  },
}

export default RemarkTags
